<template>
  <div>
    <user-add user-title="产品信息" user-add-url="/user/product_info/add"></user-add>
    <el-table :data="Cdata"  height="80vh">
      <el-table-column label="主图" fixed="left" width="100">
        <template slot-scope="scope" >
          <el-image class="item-image" :src="'http://'+Cdata[scope.$index].photoUrl" alt=""></el-image>
        </template>
      </el-table-column>
      <el-table-column label="ID" width="50" prop="id"></el-table-column>
      <el-table-column label="名称" prop="name" width="80" ></el-table-column>
      <el-table-column label="产品标签">
        <template slot-scope="scope" >
          <span v-for="(item,index) in Cdata[scope.$index].tagList" :key="index+'q'">{{item.name+'、'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="产品所属分类" width="160">
        <template slot-scope="scope" >
          <span v-for="(item,index) in Cdata[scope.$index].classifyList" :key="index+'q'">{{item.name+'、'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="商品介绍" prop="productIntroduce" width="160"></el-table-column>
      <el-table-column label="创建时间" prop="createTime" ></el-table-column>
      <el-table-column label="更新时间" prop="updateTime" ></el-table-column>
      <el-table-column label="操作" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleLook(Cdata[scope.$index].id)">查看</el-button>
          <el-button type="text" size="small" @click="handleChange(Cdata[scope.$index].id)">修改</el-button>
          <el-button type="text" size="small" @click="handleDelete(Cdata[scope.$index].id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import UserAdd from "../Common/UserAdd";
  export default {
    name: "ProductInfoBase",
    components: {UserAdd},
    data(){
      return{
        Cdata:null,//当前表格展示数据
        Cpage:null,//当前获取数据总页数
        PostData:{
          'pageNumber':0,
          'pageSize':20,
        }
      }
    },
    created() {
        this.GetData(this.PostData)
    },
    methods:{
      GetData(PageData){
        this.$axios.post('/api/productInfo/getList',PageData).then(res=>{
          this.Cdata=res.data.data

        })
      },
      handleLook(id){
        this.$router.push('/user/product_info/look'+id)
      },
      handleChange(id){
        this.$router.push('/user/product_info/change'+id)
      },
      Delete(id){
        this.$axios.delete('/api/productInfo/deleteById',{params:{
            id:id
          }}).then(res=>{
          this.GetData(this.PostData)
        })
      },
      handleDelete(id){
        this.$confirm('确定删除该条信息', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.Delete(id)
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
    }
  }
</script>

<style scoped>

</style>